import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewDidEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { UseHeader, MktEmpty } from '@cps'
import { MemberApi } from '@api/index'
import { storeMobx, memberMobx } from '@mobxStore'
import { format } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import { getGiveAmount } from '@common/utils/member'
import './index.scss'

interface IProps extends IPage, RouteComponentProps {
}

const pageSize: number = 12

const Card: FC<IProps> = ({ match }) => {
  const { type, cardNo } = match.params as any
  const cardName = memberMobx.cardList.find(item => item.cardNo === cardNo)?.card?.cardName || memberMobx.giftListForMy.find(item => item.cardNo === cardNo)?.giftcard?.giftcardName || cardNo
  const history = useHistoryNew()
  // Component State
  const [page, setPage] = useState<number>(1)
  const [logs, setLogs] = useState<any[]>([])
  const [canget, setCanget] = useState<boolean>(true)
  // Data Method
  const getData = (pageNum: number, data: any[]) => {
    const para: any = {
      brandId: storeMobx.brand.brandId,
      cardNo,
      page: pageNum,
      limit: pageSize,
      type: type,
    }
    MemberApi.getCardLogs(para).then((res: any) => {
      if (!res.error) {
        setLogs(data.concat(res.items))
        if (pageNum >= res.meta.totalPages) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }

  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        setPage(page + 1)
        ev.target.complete()
      }, 500)
    }
  }

  useEffect(() => {
    getData(page, page === 1 ? [] : logs)
  }, [page])

  useIonViewDidEnter(() => {
    getData(1, [])
  })
  return (
    <IonPage className='flow-page'>
      <UseHeader onBack={() => mktController.goBack(history)} title={cardName}></UseHeader>
      <IonContent className='page-content'>
        {logs.length === 0 && <MktEmpty />}
        {
          logs.length >= 0 &&
            <div className='flow-table'>
              {
                logs.map((item: any, index: number) => {
                  let outNo = item.outNo
                  if (item.type === 'refund' || item.type === 'integralRefund') {
                    if (item.linkLog) {
                      outNo = item.linkLog.outNo
                    } else {
                      outNo = item.remark
                    }
                  } else if (item.type === 'batchOpen') {
                    outNo = '--'
                  }
                  if (!outNo) {
                    outNo = '--'
                  }
                  return (
                    <div className='flow-item' key={index}>
                      <div className='flow-area'>
                        <div className='flow-top'>
                          <div className='type'>{outNo}</div>
                          <div className='change'>{i18n.t(`mkt.record.${item.type}`)}</div>
                          <div className='balance'>{type === 'consume' ? format.toPrice(item.balanceChange) : `${item.integralChange > 0 ? '+' : '-'} ${Math.abs(item.integralChange)}`}</div>
                        </div>
                        {getGiveAmount(item, 'balanceGiveChange') && <div className='balance-give'>{getGiveAmount(item, 'balanceGiveChange', 'consumeGiveAmount')}</div>}
                        <div className='flow-bottom'>
                          <span>{item.addTime}</span>
                          <span>{type === 'consume' ? i18n.t('decoration.balance') : i18n.t('mkt.member.remaining')} {type === 'consume' ? format.toPrice(item.balanceAfter) : item.integralAfter}{getGiveAmount(item, 'balanceGiveAfter') && <span className='consume-give'>{getGiveAmount(item, 'balanceGiveAfter')}</span>}</span>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
        }
        {
          canget &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Card)
